import { Directive, Input, OnInit } from '@angular/core';
import {
  DataSource,
  ListViewProviderDirective,
  ViewResultListener
} from '@ntap/core';
import { NoopViewProvider } from '../noop-list-view-provider';

@Directive({
  selector: '[appNoopViewProvider]',
  providers: [
    NoopViewProvider,
    {
      provide: ListViewProviderDirective,
      useExisting: NoopViewProvider,
      deps: [ViewResultListener, DataSource]
    }
  ]
})
export class NoopViewProviderDirective implements OnInit {
  @Input()
  public typeName: string;

  constructor(private viewProvider: NoopViewProvider) {}

  ngOnInit(): void {
    this.viewProvider.setItemType(this.typeName);
  }
}
